export enum VendorUIComponents {
    ControllerGroup = "controller",
    FreeSpeensInfoGroup = "free_speens_info",
    TopElementsGroup = "top_elements",
    BottomElementsGroup = "bottom_elements",
    BuyFeatureGroup = "btn_buy_feature",
}
